<template>
  <div
    v-if="backgroundImage"
    :class="cardClass"
    class="l-flex l-flex--align-end"
    :style="{ backgroundImage: `url(${backgroundImage.src})` }"
  >
    <div class="l-flex--align-end">
      <h3
        v-if="title"
        :class="titleClass"
        class="c-background-content-card__title"
      >
        {{ title }}
      </h3>
      <h4
        v-if="subtitle"
        :class="subtitleClass"
      >
        {{ subtitle }}
      </h4>
      <wysiwyg
        v-if="description"
        :html="description"
      />
      <btn
        v-if="cta"
        v-bind="cta"
        :aria-label="`${entryTitle} ${cta.text}`"
      >
        {{ cta.text }}
      </btn>
    </div>
  </div>
</template>

<script>
import Btn from '../button/Btn';
import Wysiwyg from "../wysiwyg/Wysiwyg";
/**Background CTA Content Card:
 * SUMMARY: This card is used on the homepage right below the carousel.
 */
export default {
  name: 'BackgroundCTAContentCard',
  components: {
    Btn,
    Wysiwyg
  },
  //buttonPostion can take "center" or "end"
  props: {
    entryTitle: {
      type: String,
      default: null,
    },
    backgroundImage: {
      type: Object,
      default: () => ({
        src: '',
        alt: 'background image',
      })
    },
    /**
     * Object for CTA button configuration. The structure is { type: 'primary', text: 'Call To Action', size: 'small', url: '#' }
     * Type available values: primary, secondary, primary-open, link
     * Size available values: thin, small, large
     */
    cta: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: null,
    },
    titleTypography: {
      type: String,
      default: 't-heading-1'
    },
    titleColor: {
      type: String,
      default: 'base',
    },
    subtitle: {
      type: String,
      default: null,
    },
    subtitleTypography: {
      type: String,
      default: 't-heading-2'
    },
    subtitleColor: {
      type: String,
      default: 'base',
    },
    description: {
      type: String,
      default: '',
    },
    navTile: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    titleClass() {
      let results = []
      if(this.titleTypography) {
        results.push(this.titleTypography);
      }
      if (this.titleColor) {
        results.push(this.titleTypography + '--' + this.titleColor);
      }
      if (this.subtitle && !this.description || this.cta && !this.description) {
        results.push("u-margin-bottom-medium");
      }
      return results;
    },
    subtitleClass() {
      let results = []
      if (this.subtitleTypography) {
        results.push(this.subtitleTypography);
      }
      if (this.subtitleColor) {
        results.push(this.subtitleTypography + "--" +  this.subtitleColor);
      }
      if (this.subtitle || this.cta) {
        results.push("u-margin-bottom-large");
      }
      return results;
    },
    cardClass() {
      if (this.navTile) {
        return 'c-background-content-card c-background-content-card--nav-tile'
      }
      else if(!this.title && !this.subtitle) {
        return "c-background-content-card c-background-content-card--solo-button flex "
      } else {
        return "c-background-content-card"
      }
    }
  },
  created() {
    if(!this.backgroundImage){
      console.warn("This card is potentially broken because it is missing background image.");
    }
  }
};

</script>

<style lang="scss" scoped>
  .c-background-content-card {
    height: 100%;
    text-align: center;
    padding: rem(170px) 0 rem(50px);
    background-size: cover;
    background-position: center;
    &__title {
      max-width: 80%;
      margin: auto;
    }
    &--solo-button {
      padding: rem(330px) 0 rem(33px);
    }
    &--nav-tile {
      padding: rem(86px) 0;
    }
  }
</style>
